import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const target = hash ? document.getElementById(hash.slice(1)) : null;
    window.requestAnimationFrame(() => {
      if (target) target.scrollIntoView();
      else window.scrollTo(0, 0);
    });
  }, [pathname, hash]);

  return null;
}
